import ReactJson from 'react-json-view';
import { clsx } from 'clsx';
// mantine
import { ActionIcon, Collapse, Highlight } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
// icons
import { ChevronRight } from 'lucide-react';
// components
import { useRef } from 'react';
import { IOperationLog, ILevel } from '@newo/api/gateway';
import LogItem from '@/modules/Analytics/components/SystemOutput/components/LogItem';
// utils
import { linkify } from '@/utils';
// assets
import styles from '@/modules/Analytics/components/SystemOutput/components/OperationLogItem/OperationLogItem.module.css';

interface OperationLogItemProps {
    datetime: string;
    level: ILevel;
    message: string;
    log: IOperationLog;
    searchTerm?: string;
}

const OperationLogItem = ({
    datetime,
    level,
    message,
    log,
    searchTerm
}: OperationLogItemProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const [isOpened, { toggle }] = useDisclosure(false);
    const handleClick = () => {
        toggle();
        ref.current?.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <LogItem datetime={datetime} level={level} ref={ref} type="operation">
            <div className="flex gap-2">
                <ActionIcon
                    color="gray"
                    size="xs"
                    variant="light"
                    onClick={handleClick}
                >
                    <ChevronRight
                        className={clsx({ [styles.rotated]: isOpened })}
                    />
                </ActionIcon>
                <div className="w-full truncate text-xs">
                    {searchTerm ? (
                        <Highlight
                            className="whitespace-normal"
                            highlight={searchTerm}
                            lineClamp={1}
                            size="xs"
                        >
                            {message}
                        </Highlight>
                    ) : (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: linkify(message)
                            }}
                        />
                    )}
                </div>
            </div>

            <Collapse in={isOpened}>
                <ReactJson
                    displayDataTypes={false}
                    displayObjectSize={false}
                    name={false}
                    src={log.data}
                />
            </Collapse>
        </LogItem>
    );
};

export default OperationLogItem;
